export enum TaskFilterOption {
  ALL = "All",
  ACTIVE = "Active",
  COMPLETED = "Completed",
}
